// extracted by mini-css-extract-plugin
export var heading = "FAQ-module--heading--1elsM";
export var questions_container = "FAQ-module--questions_container--kDDdi";
export var question_container = "FAQ-module--question_container--2Znp9";